<script setup lang="ts">
import {
	Toast,
	ToastClose,
	ToastDescription,
	ToastProvider,
	ToastTitle,
	ToastViewport
} from '.';
import { useToast } from './use-toast';

const { toasts } = useToast();
</script>

<template>
	<ToastProvider>
		<Toast v-for="toast in toasts" :key="toast.id" v-bind="toast">
			<div class="grid gap-1">
				<ToastTitle v-if="toast.title">
					{{ toast.title }}
				</ToastTitle>
				<ToastDescription v-if="toast.description">
					<template v-if="typeof toast.description === 'string'">
						{{ toast.description }}
					</template>
					<component :is="toast.description" v-else />
				</ToastDescription>
				<ToastClose />
			</div>
			<component :is="toast.action" />
		</Toast>
		<ToastViewport />
	</ToastProvider>
</template>
